<form
  [formGroup]="promocodeForm"
  class="promocode-form flex justify-end lg:my-4"
  [ngClass]="{ 'mb-36': !hasDiscount() }">
  <div class="promo-form-container flex flex-col">
    <mat-form-field
      color="accent"
      appearance="outline"
      class="w-[230px]"
      [hideRequiredMarker]="true">
      <mat-label>{{ 'promocode.label' | translate }}</mat-label>
      <input
        matInput
        type="text"
        formControlName="promocode"
        [attr.aria-label]="'Promo code' | translate"
        (keyup.enter)="hasValue && submit()"
        maxlength="40" />
      <mat-error *ngIf="promocodeForm.get('promocode')?.hasError('required')">
        {{ 'promocode.label.invalid' | translate }}
      </mat-error>
    </mat-form-field>
    <div
      *ngIf="canShowPromocodeSuccessMessage()"
      class="message mt-1 flex pt-1">
      <rd-shared-icon
        class="mr-2 h-4 w-4"
        [iconSymbol]="'icon-promo-success'"></rd-shared-icon>
      <span
        tabindex="0"
        #alertMessage
        class="text-[#008A02] focus:outline-none"
        role="alert">
        {{ 'promocode.apply.success' | translate }}
      </span>
    </div>
    <div *ngIf="promocodeError" class="message mr-[-20px] mt-1 flex pt-1">
      <rd-shared-icon
        class="mr-2 h-4 w-4"
        [iconSymbol]="'icon-promo-fail'"></rd-shared-icon>
      <span
        tabindex="0"
        #alertMessage
        class="text-[0.875rem] text-[#D90000] focus:outline-none"
        role="alert">
        {{ promocodeError }}
      </span>
    </div>
  </div>
  <rd-shared-button
    class="ml-3 mt-[3px] w-[100px]"
    buttonTheme="primary"
    [buttonContent]="applyButtonContent"
    (clickFn)="submit()"
    [isDisabled]="!hasValue || promocodeLoading"
    [ariaLabel]="getButtonAriaLabel() | translate">
    <ng-template #applyButtonContent>
      <span *ngIf="!promocodeLoading">
        {{ getButtonName() | translate }}
      </span>
      <img
        *ngIf="promocodeLoading"
        class="spinner-image"
        [src]="'/images/rd/processing-loading.svg' | imageUrl"
        alt="Loading in progress" />
    </ng-template>
  </rd-shared-button>
</form>
